export const BASE_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
export const USERS_URL = process.env.REACT_APP_BACKEND_SERVER_USERS_URL;
export const CATEGORY_URL = process.env.REACT_APP_BACKEND_SERVER_CATEGORY_URL;
export const PRODUCT_URL = process.env.REACT_APP_BACKEND_SERVER_PRODUCT_URL;
export const UPLOAD_URL = process.env.REACT_APP_BACKEND_SERVER_UPLOAD_URL;
export const ORDERS_URL = process.env.REACT_APP_BACKEND_SERVER_ORDERS_URL;
export const INCO_TERM_URL = process.env.REACT_APP_BACKEND_SERVER_INCO_TERM_URL;
export const PORT_URL = process.env.REACT_APP_BACKEND_SERVER_PORT_URL;
export const DISCOUNT_URL = process.env.REACT_APP_BACKEND_SERVER_DISCOUNT_URL;
export const CART_URL = process.env.REACT_APP_BACKEND_SERVER_CART_URL;
export const SHIPPING_ADDRESS_URL = process.env.REACT_APP_BACKEND_SERVER_SHIPPING_ADDRESS_URL;
